import { BsPersonBoundingBox } from "solid-icons/bs";
import { HiSolidUsers } from "solid-icons/hi";
import type { JSX } from "solid-js";
import { useI18n } from "@/api/i18n";
import type { PlanSlug } from "../api/types";

/**
 * Shared per-plan presentation for the paid sales surfaces (`/pricing` and the
 * in-app `/profile/company/upgrade`). Keeping the icon + curated bullet copy in
 * one place stops the two pages from drifting apart visually.
 */

/** Top-right circle icon for a plan card. Only the two sellable paid plans have one. */
export const planIcon = (slug: PlanSlug): JSX.Element | undefined => {
  if (slug === "headhunter") {
    return <BsPersonBoundingBox class="h-6 w-6 text-primary" />;
  }
  if (slug === "team") {
    return <HiSolidUsers class="h-6 w-6 text-[#100a1b]" />;
  }
  return undefined;
};

/**
 * Returns a getter for the design-curated feature bullets (verbatim from
 * pricing-design.html). `undefined` for plans without curated copy, so the
 * PlanCard falls back to its backend-derived lines.
 */
export const usePlanSalesFeatures = () => {
  const { t } = useI18n();
  return (slug: PlanSlug): string[] | undefined => {
    if (slug === "headhunter") {
      return [
        t("billing.sales.plan_features.hh_1"),
        t("billing.sales.plan_features.hh_2"),
        t("billing.sales.plan_features.hh_3"),
        t("billing.sales.plan_features.hh_4"),
        t("billing.sales.plan_features.hh_5"),
      ];
    }
    if (slug === "team") {
      return [
        t("billing.sales.plan_features.team_1"),
        t("billing.sales.plan_features.team_2"),
        t("billing.sales.plan_features.team_3"),
        t("billing.sales.plan_features.team_4"),
        t("billing.sales.plan_features.team_5"),
      ];
    }
    return undefined;
  };
};
